//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BackendApiV2 {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all available Betrieb objects
     * @return Array containing Betrieb objects
     */
    getAllBetriebe( cancelToken?: CancelToken): Promise<BetriebeWithChecklistenEingabenResponseDto> {
        let url_ = this.baseUrl + "/api/v2/betrieb/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBetriebe(_response);
        });
    }

    protected processGetAllBetriebe(response: AxiosResponse): Promise<BetriebeWithChecklistenEingabenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BetriebeWithChecklistenEingabenResponseDto.fromJS(resultData200);
            return Promise.resolve<BetriebeWithChecklistenEingabenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case no Betrieb found for the specified id", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BetriebeWithChecklistenEingabenResponseDto>(null as any);
    }

    /**
     * Retrieves the Betrieb by filtering on the specified Id
     * @return Returns Betrieb if found
     */
    getBetriebById(id: number, cancelToken?: CancelToken): Promise<BetriebWithChecklistenEingabenResponseDto> {
        let url_ = this.baseUrl + "/api/v2/betrieb/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBetriebById(_response);
        });
    }

    protected processGetBetriebById(response: AxiosResponse): Promise<BetriebWithChecklistenEingabenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BetriebWithChecklistenEingabenResponseDto.fromJS(resultData200);
            return Promise.resolve<BetriebWithChecklistenEingabenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case no Betrieb found for the specified id", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BetriebWithChecklistenEingabenResponseDto>(null as any);
    }

    /**
     * Saves specified ChecklistenEingabe
     * @return In case the ChecklistenEingabe have been saved successfully
     */
    postChecklistenEingabe(body: AddChecklistenEingabeRequestDto, cancelToken?: CancelToken): Promise<AddChecklistenEingabeResponseDto> {
        let url_ = this.baseUrl + "/api/v2/checklistenEingabe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostChecklistenEingabe(_response);
        });
    }

    protected processPostChecklistenEingabe(response: AxiosResponse): Promise<AddChecklistenEingabeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = AddChecklistenEingabeResponseDto.fromJS(resultData201);
            return Promise.resolve<AddChecklistenEingabeResponseDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddChecklistenEingabeResponseDto>(null as any);
    }

    /**
     * Retrieves the Checklisten Eingabe record matching the specified id.
     * @return Response containing Checklisten Eingabe record
     */
    getChecklistenEingabeByUniqueId(uniqueId: string, cancelToken?: CancelToken): Promise<GetChecklistenEingabeResponseDto> {
        let url_ = this.baseUrl + "/api/v2/checklistenEingabe/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChecklistenEingabeByUniqueId(_response);
        });
    }

    protected processGetChecklistenEingabeByUniqueId(response: AxiosResponse): Promise<GetChecklistenEingabeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetChecklistenEingabeResponseDto.fromJS(resultData200);
            return Promise.resolve<GetChecklistenEingabeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChecklistenEingabeResponseDto>(null as any);
    }

    /**
     * Deletes a ChecklistenEingabe
     * @return In case the ChecklistenEingabe was successfully deleted
     */
    deleteChecklistenEingabeByUniqueId(uniqueId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/checklistenEingabe/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChecklistenEingabeByUniqueId(_response);
        });
    }

    protected processDeleteChecklistenEingabeByUniqueId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Serves ChecklistenEingabe as PDF
     * @return Response containing Checklisten Eingabe record as pdf
     */
    getPdfChecklistenEingabeByUniqueId(uniqueId: string, cancelToken?: CancelToken): Promise<PdfResponseDto> {
        let url_ = this.baseUrl + "/api/v2/checklistenEingabe/{uniqueId}/pdf";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdfChecklistenEingabeByUniqueId(_response);
        });
    }

    protected processGetPdfChecklistenEingabeByUniqueId(response: AxiosResponse): Promise<PdfResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PdfResponseDto.fromJS(resultData200);
            return Promise.resolve<PdfResponseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("In case when the Checkliste wasn\'t found", status, _responseText, _headers);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = PdfTemplateValidationResultDto.fromJS(resultData422);
            return throwException("In case the PdfTemplate or ChecklistenEingabe is mismatch to the correspond Checkliste by fields", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResponseDto>(null as any);
    }
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export class AddChecklistenEingabeDto implements IAddChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId!: number;
    /** A unique ID of a Checkliste */
    checklistenId!: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName!: string;
    /** The content of ChecklistenEingabe */
    eingabe!: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc!: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;

    constructor(data?: IAddChecklistenEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betriebId = _data["betriebId"];
            this.checklistenId = _data["checklistenId"];
            this.checklistenEingabeName = _data["checklistenEingabeName"];
            this.eingabe = _data["eingabe"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): AddChecklistenEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betriebId"] = this.betriebId;
        data["checklistenId"] = this.checklistenId;
        data["checklistenEingabeName"] = this.checklistenEingabeName;
        data["eingabe"] = this.eingabe;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export interface IAddChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId: number;
    /** A unique ID of a Checkliste */
    checklistenId: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName: string;
    /** The content of ChecklistenEingabe */
    eingabe: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;
}

/** Represents Request-Container for saving the ChecklistenEingabe */
export class AddChecklistenEingabeRequestDto implements IAddChecklistenEingabeRequestDto {
    checklistenEingabe!: AddChecklistenEingabeDto;

    constructor(data?: IAddChecklistenEingabeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new AddChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? AddChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new AddChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): AddChecklistenEingabeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents Request-Container for saving the ChecklistenEingabe */
export interface IAddChecklistenEingabeRequestDto {
    checklistenEingabe: AddChecklistenEingabeDto;
}

/** Provides a Response-Container for saving Checklisten Eingabe entry */
export class AddChecklistenEingabeResponseDto implements IAddChecklistenEingabeResponseDto {
    checklistenEingabe!: ChecklistenEingabeDto;

    constructor(data?: IAddChecklistenEingabeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new ChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? ChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new ChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): AddChecklistenEingabeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Provides a Response-Container for saving Checklisten Eingabe entry */
export interface IAddChecklistenEingabeResponseDto {
    checklistenEingabe: ChecklistenEingabeDto;
}

export class BetriebWithChecklistenEingabenDto implements IBetriebWithChecklistenEingabenDto {
    /** Der Name eines Betriebes */
    name!: string;
    vvvo!: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname!: string;
    /** Die Straße eines Betriebes */
    strasse!: string;
    /** Die PLZ eines Betriebes */
    postleitzahl!: string;
    /** Der Ort eines Betriebes */
    ort!: string;
    /** Die Email eines Betriebes */
    email!: string;
    /** Eine eindeutige Id eines Betriebes */
    id!: number;
    authorized?: boolean;
    checklistenEingaben?: ChecklistenEingabeDto[] | undefined;
    checklistenEingabenCount?: number;
    checklistenEingabenLoadedCount?: number;

    constructor(data?: IBetriebWithChecklistenEingabenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
            this.vorname = _data["vorname"];
            this.strasse = _data["strasse"];
            this.postleitzahl = _data["postleitzahl"];
            this.ort = _data["ort"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.authorized = _data["authorized"];
            if (Array.isArray(_data["checklistenEingaben"])) {
                this.checklistenEingaben = [] as any;
                for (let item of _data["checklistenEingaben"])
                    this.checklistenEingaben!.push(ChecklistenEingabeDto.fromJS(item));
            }
            this.checklistenEingabenCount = _data["checklistenEingabenCount"];
            this.checklistenEingabenLoadedCount = _data["checklistenEingabenLoadedCount"];
        }
    }

    static fromJS(data: any): BetriebWithChecklistenEingabenDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebWithChecklistenEingabenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        data["vorname"] = this.vorname;
        data["strasse"] = this.strasse;
        data["postleitzahl"] = this.postleitzahl;
        data["ort"] = this.ort;
        data["email"] = this.email;
        data["id"] = this.id;
        data["authorized"] = this.authorized;
        if (Array.isArray(this.checklistenEingaben)) {
            data["checklistenEingaben"] = [];
            for (let item of this.checklistenEingaben)
                data["checklistenEingaben"].push(item.toJSON());
        }
        data["checklistenEingabenCount"] = this.checklistenEingabenCount;
        data["checklistenEingabenLoadedCount"] = this.checklistenEingabenLoadedCount;
        return data;
    }
}

export interface IBetriebWithChecklistenEingabenDto {
    /** Der Name eines Betriebes */
    name: string;
    vvvo: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname: string;
    /** Die Straße eines Betriebes */
    strasse: string;
    /** Die PLZ eines Betriebes */
    postleitzahl: string;
    /** Der Ort eines Betriebes */
    ort: string;
    /** Die Email eines Betriebes */
    email: string;
    /** Eine eindeutige Id eines Betriebes */
    id: number;
    authorized?: boolean;
    checklistenEingaben?: ChecklistenEingabeDto[] | undefined;
    checklistenEingabenCount?: number;
    checklistenEingabenLoadedCount?: number;
}

export class BetriebWithChecklistenEingabenResponseDto implements IBetriebWithChecklistenEingabenResponseDto {
    betrieb!: BetriebWithChecklistenEingabenDto;

    constructor(data?: IBetriebWithChecklistenEingabenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betrieb = new BetriebWithChecklistenEingabenDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? BetriebWithChecklistenEingabenDto.fromJS(_data["betrieb"]) : new BetriebWithChecklistenEingabenDto();
        }
    }

    static fromJS(data: any): BetriebWithChecklistenEingabenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebWithChecklistenEingabenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBetriebWithChecklistenEingabenResponseDto {
    betrieb: BetriebWithChecklistenEingabenDto;
}

/** Repräsentiert einen Betriebe eines Users */
export class BetriebeWithChecklistenEingabenResponseDto implements IBetriebeWithChecklistenEingabenResponseDto {
    /** Eine Liste mit den Betrieben eines Users */
    betriebe!: BetriebWithChecklistenEingabenDto[];

    constructor(data?: IBetriebeWithChecklistenEingabenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betriebe = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["betriebe"])) {
                this.betriebe = [] as any;
                for (let item of _data["betriebe"])
                    this.betriebe!.push(BetriebWithChecklistenEingabenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BetriebeWithChecklistenEingabenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebeWithChecklistenEingabenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.betriebe)) {
            data["betriebe"] = [];
            for (let item of this.betriebe)
                data["betriebe"].push(item.toJSON());
        }
        return data;
    }
}

/** Repräsentiert einen Betriebe eines Users */
export interface IBetriebeWithChecklistenEingabenResponseDto {
    /** Eine Liste mit den Betrieben eines Users */
    betriebe: BetriebWithChecklistenEingabenDto[];
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export class ChecklistenEingabeDto implements IChecklistenEingabeDto {
    /** Checklisten Eingabe id */
    id?: number;
    /** Indicates whether ChecklistenEingabe is valid comparing with Checkliste and Pdf Template */
    isValid?: boolean | undefined;
    /** Name of the concrete ChecklistenEingabe */
    checklistenName!: string;
    /** Indicates whether Checkliste related to ChecklistenEingabe has newer version */
    isOutdated?: boolean;
    /** User who crated ChecklistenEingabe */
    author?: string | undefined;
    description?: string | undefined;
    /** A unique ID of a Betrieb */
    betriebId!: number;
    /** A unique ID of a Checkliste */
    checklistenId!: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName!: string;
    /** The content of ChecklistenEingabe */
    eingabe!: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc!: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;

    constructor(data?: IChecklistenEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isValid = _data["isValid"];
            this.checklistenName = _data["checklistenName"];
            this.isOutdated = _data["isOutdated"];
            this.author = _data["author"];
            this.description = _data["description"];
            this.betriebId = _data["betriebId"];
            this.checklistenId = _data["checklistenId"];
            this.checklistenEingabeName = _data["checklistenEingabeName"];
            this.eingabe = _data["eingabe"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): ChecklistenEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistenEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isValid"] = this.isValid;
        data["checklistenName"] = this.checklistenName;
        data["isOutdated"] = this.isOutdated;
        data["author"] = this.author;
        data["description"] = this.description;
        data["betriebId"] = this.betriebId;
        data["checklistenId"] = this.checklistenId;
        data["checklistenEingabeName"] = this.checklistenEingabeName;
        data["eingabe"] = this.eingabe;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export interface IChecklistenEingabeDto {
    /** Checklisten Eingabe id */
    id?: number;
    /** Indicates whether ChecklistenEingabe is valid comparing with Checkliste and Pdf Template */
    isValid?: boolean | undefined;
    /** Name of the concrete ChecklistenEingabe */
    checklistenName: string;
    /** Indicates whether Checkliste related to ChecklistenEingabe has newer version */
    isOutdated?: boolean;
    /** User who crated ChecklistenEingabe */
    author?: string | undefined;
    description?: string | undefined;
    /** A unique ID of a Betrieb */
    betriebId: number;
    /** A unique ID of a Checkliste */
    checklistenId: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName: string;
    /** The content of ChecklistenEingabe */
    eingabe: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;
}

/** Provides a Response-Container for a Checklisten Eingabe entry */
export class GetChecklistenEingabeResponseDto implements IGetChecklistenEingabeResponseDto {
    checklistenEingabe!: ChecklistenEingabeDto;

    constructor(data?: IGetChecklistenEingabeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new ChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? ChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new ChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): GetChecklistenEingabeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChecklistenEingabeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Provides a Response-Container for a Checklisten Eingabe entry */
export interface IGetChecklistenEingabeResponseDto {
    checklistenEingabe: ChecklistenEingabeDto;
}

export class MismatchedPdfTemplateFieldDto implements IMismatchedPdfTemplateFieldDto {
    cause?: string | undefined;
    pathParts?: PdfTemplateFieldPathPartDto[] | undefined;
    possibleMatches?: any[] | undefined;
    valueType?: string | undefined;
    elementType?: string | undefined;

    constructor(data?: IMismatchedPdfTemplateFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cause = _data["cause"];
            if (Array.isArray(_data["pathParts"])) {
                this.pathParts = [] as any;
                for (let item of _data["pathParts"])
                    this.pathParts!.push(PdfTemplateFieldPathPartDto.fromJS(item));
            }
            if (Array.isArray(_data["possibleMatches"])) {
                this.possibleMatches = [] as any;
                for (let item of _data["possibleMatches"])
                    this.possibleMatches!.push(item);
            }
            this.valueType = _data["valueType"];
            this.elementType = _data["elementType"];
        }
    }

    static fromJS(data: any): MismatchedPdfTemplateFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new MismatchedPdfTemplateFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cause"] = this.cause;
        if (Array.isArray(this.pathParts)) {
            data["pathParts"] = [];
            for (let item of this.pathParts)
                data["pathParts"].push(item.toJSON());
        }
        if (Array.isArray(this.possibleMatches)) {
            data["possibleMatches"] = [];
            for (let item of this.possibleMatches)
                data["possibleMatches"].push(item);
        }
        data["valueType"] = this.valueType;
        data["elementType"] = this.elementType;
        return data;
    }
}

export interface IMismatchedPdfTemplateFieldDto {
    cause?: string | undefined;
    pathParts?: PdfTemplateFieldPathPartDto[] | undefined;
    possibleMatches?: any[] | undefined;
    valueType?: string | undefined;
    elementType?: string | undefined;
}

/** Response-Container containing PdfCheckliste */
export class PdfDto implements IPdfDto {
    /** The name of file */
    filename!: string;
    /** contentType of file */
    contentType!: string;
    /** The file extension */
    extension!: string;
    /** File data */
    data!: string;
    /** The size of file */
    fileSize!: number;

    constructor(data?: IPdfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.contentType = _data["contentType"];
            this.extension = _data["extension"];
            this.data = _data["data"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): PdfDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["contentType"] = this.contentType;
        data["extension"] = this.extension;
        data["data"] = this.data;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

/** Response-Container containing PdfCheckliste */
export interface IPdfDto {
    /** The name of file */
    filename: string;
    /** contentType of file */
    contentType: string;
    /** The file extension */
    extension: string;
    /** File data */
    data: string;
    /** The size of file */
    fileSize: number;
}

/** Response-Container containing PdfCheckliste */
export class PdfResponseDto implements IPdfResponseDto {
    pdf!: PdfDto;

    constructor(data?: IPdfResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new PdfDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdf = _data["pdf"] ? PdfDto.fromJS(_data["pdf"]) : new PdfDto();
        }
    }

    static fromJS(data: any): PdfResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        return data;
    }
}

/** Response-Container containing PdfCheckliste */
export interface IPdfResponseDto {
    pdf: PdfDto;
}

export class PdfTemplateFieldPathPartDto implements IPdfTemplateFieldPathPartDto {
    value?: string | undefined;
    isIgnored?: boolean;

    constructor(data?: IPdfTemplateFieldPathPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isIgnored = _data["isIgnored"];
        }
    }

    static fromJS(data: any): PdfTemplateFieldPathPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfTemplateFieldPathPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isIgnored"] = this.isIgnored;
        return data;
    }
}

export interface IPdfTemplateFieldPathPartDto {
    value?: string | undefined;
    isIgnored?: boolean;
}

export class PdfTemplateValidationResultDto implements IPdfTemplateValidationResultDto {
    messages?: MismatchedPdfTemplateFieldDto[] | undefined;
    additionalData?: any | undefined;
    isValid?: boolean;

    constructor(data?: IPdfTemplateValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MismatchedPdfTemplateFieldDto.fromJS(item));
            }
            this.additionalData = _data["additionalData"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): PdfTemplateValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfTemplateValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["additionalData"] = this.additionalData;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IPdfTemplateValidationResultDto {
    messages?: MismatchedPdfTemplateFieldDto[] | undefined;
    additionalData?: any | undefined;
    isValid?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class VvvoDto implements IVvvoDto {
    value!: string;

    constructor(data?: IVvvoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VvvoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VvvoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IVvvoDto {
    value: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}